export default __webpack_public_path__ + "static/media/app_cover.f586cca0.png";